const QRCODE_BASE_URL = 'https://qrcoud.com/?';

export default QRCODE_BASE_URL;
